import ReactSelect from "components/Form/Select/Select";
import rest from "lib/rest";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import rotas from "services/rotas";
import Swal from "sweetalert2";


const NfeCPag = ({ onClose, cnpj }) => {

  const inititalForm = {
    estabelecimento: [],
    planoContas: [],
    centroCusto: [],
    referencia: ''
  }

  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [planoContas, setPlanoContas] = useState([]);
  const [centroCusto, setCentroCusto] = useState([]);
  const [form, setForm] = useState(inititalForm);

  useEffect(() => {
    listarEstabelecimentos();
    listarPlanoContas();
    listarCentroCusto();
  }, [])

  const onChange = (e) => {
    let frm = { ...form };

    frm[e.target.name] = e.target.value;

    setForm(frm);
  }

  const onChangeSelect = (e, campo) => {
    const parametros = {
      target: {
        name: campo,
        value: e
      }
    }

    onChange(parametros);
  }

  const listarEstabelecimentos = () => {
    const url = rotas.estabelecimento;

    const retorno = rest.get(url);

    let lst = [];

    retorno.then(ret => {
      if (ret.success == 'S') {

        ret.lista.map(item => {
          lst.push({ id: item.estabelecimento_id, title: item.estabelecimento });
        })

        setEstabelecimentos(lst);
      }
    })
  }

  const listarPlanoContas = () => {
    const url = rotas.planoContas;

    const retorno = rest.get(url);

    let lst = [];

    retorno.then(ret => {
      if (ret.success == 'S') {

        ret.lista.map(item => {
          lst.push({ id: item.plano_contas_id, title: item.plano_contas });
        })

        setPlanoContas(lst);
      }
    })
  }

  const listarCentroCusto = () => {
    const url = rotas.centroCusto;

    const retorno = rest.get(url);

    let lst = [];

    retorno.then(ret => {
      if (ret.success == 'S') {

        ret.lista.map(item => {
          lst.push({ id: item.centro_custo_id, title: item.centro_custo });
        })

        setCentroCusto(lst);
      }
    })
  }

  const GravarCpag = () => {
    const url = rotas.nfeCpag;

    if ((form.estabelecimento.lenght == 0) ||
      (form.planoContas.lenght == 0) ||    
      (form.referencia == '')) {
      Swal.fire('Atenção', 'Por Favor Preencha Todos os Campos', 'warning');
      return;
    }

    let frm = form;

    frm.cnpj = cnpj;

    const parametros = {
      form:frm
    }

    const retorno = rest.post(url, parametros);

    retorno.then(ret => {
      if (ret.success == 'S') {
        onClose();
      } else {
        Swal.fire('Atenção', 'Erro ao Gravar o Registro!', 'error');
      }
    })

  }

  return (
    <>      
      <ModalHeader>Contas a Pagar para NF-e</ModalHeader>      
      <ModalBody>
        <Row>          
          <Col md=''>
            <FormGroup>
              <ReactSelect
                name="estabelecimento"
                placeholder="Selecione o Estabelecimento"
                options={estabelecimentos}
                defaultValue={form.estabelecimento}
                onChange={(e) => { onChangeSelect(e, 'estabelecimento') }}
                erro={form.estabelecimento.id > 0 ? false : true}
              ></ReactSelect>
              {/* <FormFeedback>Preenchimento obrigatório</FormFeedback> */}
            </FormGroup>
          </Col>

          <Col md=''>
            <FormGroup>
              <ReactSelect
                name="pano-contas"
                placeholder="Selecione o Plano de Contas"
                options={planoContas}
                defaultValue={form.planoContas}
                onChange={(e) => { onChangeSelect(e, 'planoContas') }}
                erro={form.planoContas.id > 0 ? false : true}
              ></ReactSelect>
              {/* <FormFeedback>Preenchimento obrigatório</FormFeedback> */}
            </FormGroup>
          </Col>

        </Row>

        <Row className="mt-2">

          <Col md=''>
            <FormGroup>
              <ReactSelect
                name="centro-custo"
                placeholder="Selecione o Centro de Custo"
                options={centroCusto}
                defaultValue={form.centroCusto}
                onChange={(e) => { onChangeSelect(e, 'centroCusto') }}
              ></ReactSelect>
            </FormGroup>
          </Col>

          <Col >
            <FormGroup className="mb-0">
              {/* <Label for="markup">% Markup</Label> */}
              <Input
                name="referencia"
                placeholder="Referência"
                // className={disabledMarkup ? 'disabledCampo' : ''}
                // onFocus={focusMarkup}
                // onBlur={calculaMKP}
                onChange={onChange}
                defaultValue={form.referencia}
                invalid={form.referencia == '' ? true : false}
              />
              <FormFeedback>Preenchimento obrigatório</FormFeedback>
            </FormGroup>
          </Col>

        </Row>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={GravarCpag}>Gravar</Button>
            <Button className="bg-danger" onClick={() => { onClose() }}>Fechar</Button>
          </Col>
        </Row>
      </ModalFooter>
    </>
  );
}

export default NfeCPag; 